import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, Container, Chip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import apiService from './services/api';
import logoWhite from './assets/re-stat-logo-white.svg';

// Pages
import PortalManagement from './pages/PortalManagement';
import Statistics from './pages/Statistics';
import SearchLog from './pages/SearchLog';
import Login from './pages/Login';

// Components
import ProtectedRoute from './components/ProtectedRoute';

const NAV = [
  { to: '/portals', label: 'Portali' },
  { to: '/calls', label: 'Log Ricerche' },
  { to: '/statistics', label: 'Statistiche' },
];

function AppContent() {
  const [userName, setUserName] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';

  useEffect(() => {
    if (apiService.isAdminAuthenticated()) {
      const adminUser = apiService.getAdminUser();
      setUserName(adminUser?.full_name || adminUser?.username || 'Admin');
    } else {
      setUserName(null);
    }
  }, [location]);

  const handleLogout = () => {
    apiService.adminLogout();
    setUserName(null);
    navigate('/login');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      {!isLoginPage && (
        <AppBar position="static" elevation={0} sx={{ bgcolor: '#112337' }}>
          <Toolbar sx={{ minHeight: { xs: 72, sm: 80 } }}>
            <Box component="img" src={logoWhite} alt="re-stat" sx={{ height: 40, mr: 2 }} />
            <Chip label="Admin" size="small" sx={{ mr: 3, bgcolor: 'rgba(255,255,255,0.15)', color: '#fff', fontWeight: 600 }} />
            <Box sx={{ display: 'flex', gap: 0.5, flexGrow: 1 }}>
              {NAV.map((item) => {
                const active = location.pathname === item.to;
                return (
                  <Button
                    key={item.to}
                    component={Link}
                    to={item.to}
                    sx={{
                      color: active ? '#fff' : 'rgba(255,255,255,0.7)',
                      bgcolor: active ? 'rgba(255,255,255,0.10)' : 'transparent',
                      fontWeight: active ? 700 : 500,
                    }}
                  >
                    {item.label}
                  </Button>
                );
              })}
            </Box>
            {userName && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)' }}>{userName}</Typography>
                <Button color="inherit" size="small" startIcon={<LogoutIcon />} onClick={handleLogout}>
                  Logout
                </Button>
              </Box>
            )}
          </Toolbar>
        </AppBar>
      )}

      <Container maxWidth="lg" sx={{ py: isLoginPage ? 0 : 4 }} disableGutters={isLoginPage}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/portals" replace />} />
          <Route path="/portals" element={<ProtectedRoute><PortalManagement /></ProtectedRoute>} />
          <Route path="/calls" element={<ProtectedRoute><SearchLog /></ProtectedRoute>} />
          <Route path="/statistics" element={<ProtectedRoute><Statistics /></ProtectedRoute>} />
        </Routes>
      </Container>
    </Box>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
